/** DNS 逻辑 field key（platform access-policy 与 capabilities 共用，避免 platform → capabilities 反向依赖） */
export const DNS_FIELD_KEYS = {
  nameservers: 'network.dns.nameservers',
  searches: 'network.dns.searches',
  options: 'network.dns.options',
} as const;

export const DNS_FIELD_KEY_LIST = [DNS_FIELD_KEYS.nameservers, DNS_FIELD_KEYS.searches, DNS_FIELD_KEYS.options] as const;

/** DNS 逻辑字段 key（不受 SKU type / baseline 锁定策略约束） */
export function isDnsFieldKey(field: string): boolean {
  return (DNS_FIELD_KEY_LIST as readonly string[]).includes(field);
}
